import { call, put, takeLatest, cancelled, fork, take, cancel } from 'redux-saga/effects';
import { listCalendarsAPI, deleteCalendarAPI } from '../../../utils/api';
import { generateToast } from '../../App/actions';
import { FETCH_CALENDARS_REQUEST, DELETE_CALENDAR_REQUEST, CANCEL_FETCH_CALENDARS } from './constants';
import {
	fetchCalendarsSuccess,
	fetchCalendarsFailure,
	deleteCalendarSuccess,
	deleteCalendarFailure,
} from './actions';

// This is the "worker" saga
function* fetchCalendarsSaga() {
	const controller = new AbortController();
	try {
		const calendars = yield call(listCalendarsAPI, { signal: controller.signal });
		// listCalendarsAPI returns undefined on cancellation, so we only proceed if we get data.
		if (calendars) {
			yield put(fetchCalendarsSuccess(calendars));
		}
	} catch (err) {
		// Any error caught here is a real error, not a cancellation.
		// The API utility has already formatted the error message.
		yield put(fetchCalendarsFailure(err.message));
	} finally {
		if (yield cancelled()) {
			controller.abort();
		}
	}
}

// This is the "watcher" saga that manages the worker
function* watchFetchCalendars() {
  let task;
  while (true) {
    const action = yield take([FETCH_CALENDARS_REQUEST, CANCEL_FETCH_CALENDARS]);
    if (action.type === CANCEL_FETCH_CALENDARS && task) {
      yield cancel(task);
      task = null;
    }
    if (action.type === FETCH_CALENDARS_REQUEST) {
      if (task) {
        yield cancel(task);
      }
      task = yield fork(fetchCalendarsSaga);
    }
  }
}

function* deleteCalendarSaga(action) {
	try {
		yield call(deleteCalendarAPI, action.calendarId);
		yield put(deleteCalendarSuccess(action.calendarId));
		yield put(generateToast({ type: 'success', text: 'Calendar deleted successfully.' }));
	} catch (err) {
		yield put(deleteCalendarFailure(err.message));
		yield put(generateToast({ type: 'error', text: err.message }));
	}
}

export default function* googleCalendarManagerSaga() {
	yield fork(watchFetchCalendars);
	yield takeLatest(DELETE_CALENDAR_REQUEST, deleteCalendarSaga);
}
